import { render, staticRenderFns } from "./AcademyBooks.vue?vue&type=template&id=b1f2bfa4&"
import script from "./AcademyBooks.vue?vue&type=script&lang=js&"
export * from "./AcademyBooks.vue?vue&type=script&lang=js&"
import style0 from "./AcademyBooks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports